const selectColorWraps = document.querySelectorAll(".input-color-wrap");
if(selectColorWraps.length) {
    Array.from(selectColorWraps).forEach(colorInput => {
        const select = colorInput.querySelector("select");
        select.addEventListener("change", ()=>{
            colorInput.querySelector(".color-display").style.backgroundColor = select.value;
        })
    })
}